import { CalendarBlank, ChartBar, Files, Folders, Info, Note } from "@phosphor-icons/react"

interface MenuItem {
    id: number
    name: string
    icon: (args1: string ) => React.ReactNode
    roles: string[]
    subItems?: SubItem[]
    url?: string
}

interface SubItem {
    name: string
    url: string
    roles: string[]
}

const menuList: MenuItem[] = [
    {
        id: 1,
        name: 'Dashboards',
        icon: (color: string = "#FFF") => <ChartBar size="24px" color={color} weight="bold" />,
        roles: [],
        subItems: [
            {
                name: 'Operacional',
                url: '/dashboards/operacional',
                roles: [],
            },
        ]
    },
    // {
    //     id: 7,
    //     name: 'Relatórios',
    //     icon: (color: string = "#FFF") => <Files size="24px" color={color} weight="bold" />,
    //     roles: [],
    //     url: '/relatorios',
    // },
    {
        id: 2,
        name: 'Administração',
        icon: (color: string = "#FFF") => <Folders size="24px" color={color} weight="bold" />,
        roles: [],
        subItems: [
            {
                name: 'Vidas',
                url: '/administracao/vidas',
                roles: [],
            },
            {
                name: 'Vidas com Alto Risco',
                url: '/administracao/alto-risco',
                roles: [],
            },
            {
                name: 'Monitoramento de Glicemia',
                url: '/administracao/monitoramento',
                roles: [],
            },
            {
                name: 'Usuários',
                url: '/administracao/usuarios',
                roles: [],
            },
        ]
    },
    // {
    //     id: 3,
    //     name: 'Notas de Publicação',
    //     icon: <Note size="24px" color="#FFF" weight="bold" />,
    //     roles: [],
    //     url: '/notas',
    // },
    // {
    //     id: 3,
    //     name: 'Eventos',
    //     icon: <CalendarBlank size="24px" color="#FFF" weight="bold" />,
    //     subItems: [
    //         {
    //             name: 'Calendário',
    //             url: '/eventos/calendario',
    //         },
    //         {
    //             name: 'Compromissos',
    //             url: '/eventos/compromissos',
    //         },
    //     ]
    // },
    // {
    //     id: 8,
    //     name: 'Central de Suporte',
    //     icon: <Info size="24px" weight="bold" />,
    //     url: '/suporte/atendimento',
    // },
]

export default menuList